import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import QuestionPreview from "../QuestionPreview";
import useStyles from "./styles";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import {
  CheckCircleRounded,
  RadioButtonUncheckedRounded,
} from "@mui/icons-material";
import useWindowSize from "../WindowSizeHook";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import config from "../../../config/config";
import { getTranslation } from "../../../locales";

const setDefaultValues = (values, choices) => {
  return choices.map((choice) => {
    return { ...choice, checked: values.includes(choice.value) };
  });
};

const AnswerImageSelect = (props) => {
  const contentBaseUrl = `${config.API_SERVER_URL}`;

  const styles = useStyles(props);
  const [viewAllchoices, setViewAllChoices] = useState(false);
  const { isDesktop, isTablet } = useWindowSize();
  const VIEW_MORE_LIMIT = isDesktop ? 9 : isTablet ? 9 : 3;

  const [choices, setChoices] = useState(
    setDefaultValues(props.value, props.choices)
  );

  const [selectedChoices, setSelectedChoices] = useState(props.value);

  const { isMobile } = useWindowSize();

  useEffect(() => {
    props.value.forEach((item) => {
      let selectedChoiceIndex = choices.findIndex(
        (element) => element.value === item
      );
      handleChange(
        selectedChoiceIndex,
        choices[selectedChoiceIndex],
        true,
        false
      );
    });
  }, [props.value]);

  // useEffect(() => {
  //   const contUrls = props.choices.map((choice) => choice.imageUrl);
  //   if (
  //     contUrls.length > 0 &&
  //     isValidImageArray(contUrls) &&
  //     isValidImageArray(props.choices)
  //   ) {
  //     getContentUrlsFromBlobIdsSurveyTaker(contUrls, props.surveyId)
  //       .then((contentUrlMapping) => {
  //         const newContUrls = contUrls.map((url) => contentUrlMapping[url]);
  //         setContentUrls(newContUrls);
  //       })
  //       .catch(() => {});
  //   }
  // }, [props.choices]);

  const handleChange = (index, choice, checked, updateParent = true) => {
    let updatedChoices = [...choices];
    let updatedSelectedChoices = [...selectedChoices];

    if (props.isMultipleAnswers) {
      updatedChoices[index].checked = checked;
      if (checked) {
        updatedSelectedChoices.push(choice.value);
        updatedSelectedChoices = Array.from(new Set(updatedSelectedChoices));
      } else {
        const selectedIndex = selectedChoices.indexOf(index);
        if (selectedIndex > -1) {
          updatedSelectedChoices.splice(selectedIndex, 1);
        }
      }
    } else {
      updatedChoices = updatedChoices.map((_choice, idx) => ({
        ..._choice,
        checked: idx === index ? checked : false,
      }));
      if (checked) {
        updatedSelectedChoices = [choice.value];
      } else {
        updatedSelectedChoices = [];
      }
    }

    setChoices(updatedChoices);
    setSelectedChoices(updatedSelectedChoices);

    if (updateParent) props.handleChange(updatedSelectedChoices);
  };

  const renderCheckbox = (index, choice) => {
    const checkboxIcons = props.isMultipleAnswers
      ? {}
      : {
          icon: <RadioButtonUncheckedRounded />,
          checkedIcon: <CheckCircleRounded />,
        };

    return (
      <Checkbox
        {...checkboxIcons}
        data-testid={`select-image-${index}`}
        className={styles.checkbox}
        checked={choice.checked}
        onChange={(e) => handleChange(index, choice, e.target.checked)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleChange(index, choice, e.target.checked);
          }
        }}
        value={index}
      />
    );
  };

  const renderChoice = (choice, index) => {
    return (
      <Grid item key={choice.value} xs={12} sm={3} md={3}>
        <div className={styles.choiceContainer}>
          <div className={styles.imageContainer}>
            {!isMobile && renderCheckbox(index, choice)}
            <img
              src={`${contentBaseUrl}${choice.imagePath}`}
              className={styles.image}
            />
          </div>
          <div className={styles.choiceText}>
            c{`${index + 1}`}.&nbsp;&nbsp;&nbsp;{`${choice.label}`}
          </div>
          {isMobile && renderCheckbox(index, choice)}
        </div>
      </Grid>
    );
  };

  return (
    <div className={styles.questionWrapper}>
      <QuestionPreview
        question={props.question}
        required={props.required}
        helperText={props.helperText}
      />
      <div className={styles.answer}>
        <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
          {/*Rendering all image cards*/}
          {(choices.length < VIEW_MORE_LIMIT || viewAllchoices) &&
            choices.map((v, i) => renderChoice(v, i))}
          {/*Rendering 10 image cards*/}
          {choices.length >= VIEW_MORE_LIMIT &&
            !viewAllchoices &&
            choices.map((v, i) => {
              if (i < VIEW_MORE_LIMIT - 1) return renderChoice(v, i);
            })}
        </Grid>
        <div>
          {choices.length >= VIEW_MORE_LIMIT && !viewAllchoices && (
            <div className={styles.viewWrapper}>
              <span className={styles.sides}></span>
              <button
                className={styles.viewAllChoices}
                onClick={() => setViewAllChoices(true)}
              >
                {getTranslation(props.currentLang, "surveyTaker:viewMore")}{" "}
                <ExpandMoreIcon />
              </button>
              <span className={styles.sides}></span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

AnswerImageSelect.defaultProps = {
  question: "",
  required: false,
  handleChange: () => {},
  value: "",
};

AnswerImageSelect.propTypes = {
  question: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.array.isRequired,
  helperText: PropTypes.string,
  maxChar: PropTypes.number,
};

export default AnswerImageSelect;
